export default __webpack_public_path__ + "static/media/background_planet-04_bottom.e1b3d453.jpg";